import { trackCdp, trackEvent, trackGA } from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.AccessoriesIndex.init());

Sq.Shop.AccessoriesIndex = {
  utils: Sq.Shop.Utils,
  pageId: '#accessories-index-page',

  init() {
    if ($(this.pageId).length === 0) {
      return;
    }

    this.getHtml();
    this.loadData();
    this.bindEvents();
  },

  getHtml() {
    this.$page = $(this.pageId);
    this.$productSelect = $('#product-select');
  },

  loadData() {
    $(document).ready(() => {
      this.productAccessoriesMap = JSON.parse(
        $('#accessories-container').attr('data-product-accessories')
      );
      if (this.$productSelect.length > 0) {
        const selectedProduct = this.$productSelect.val();
        $(`.results#${selectedProduct}`).removeClass('hidden');
        this.$productSelect.data('pre', selectedProduct);
      }
      this.filterByParams();
    });
  },

  bindEvents() {
    this.$page.on('click', `[${this.utils.PRODUCT_DATA_ATTR}]`, (e) =>
      this.onProductClick(e)
    );
    this.$productSelect.on('change', () => this.filterProducts());
  },

  filterByParams() {
    const filterSearch = new URLSearchParams(window.location.search).get(
      'filter'
    );
    if (
      filterSearch &&
      this.$productSelect.find(`option[value="${filterSearch}"]`).length > 0
    ) {
      this.$productSelect.val(filterSearch);
      this.filterProducts();
    } else {
      this.displayAccessoriesForProduct('all');
    }
  },

  filterProducts() {
    const previousProduct = this.$productSelect.data('pre');
    const selectedProduct = this.$productSelect.val();

    // update URL without reloading to allow link with filter applied
    window.history.replaceState(null, '', `?filter=${selectedProduct}`);

    $(`.results#${previousProduct}`).addClass('hidden');
    $(`.results#${selectedProduct}`).removeClass('hidden');

    this.$productSelect.data('pre', selectedProduct);
    this.displayAccessoriesForProduct(selectedProduct);
  },

  displayAccessoriesForProduct(selectedProduct) {
    $('.accessory-tile').addClass('hidden');

    const accessoriesSlugs = this.productAccessoriesMap[selectedProduct];
    accessoriesSlugs.forEach((slug) => {
      const $accessory = $(`.accessory-tile.${slug}`);
      $accessory.removeClass('hidden');
      $accessory.remove();
      $accessory.appendTo('#accessories-container');
    });
  },

  onProductClick(e) {
    const product = this.utils.productData(e.currentTarget);
    product.list = 'Accessories';

    trackGA('ec:addProduct', product);
    trackGA('ec:setAction', 'click', { list: 'Accessories' });
    trackEvent({
      name: 'Product',
      value: 'Click',
      params: product,
    });
    trackCdp({
      name: 'Click Product',
      params: {
        feature: 'shop',
        sku: product.sku,
      },
    });
  },
};
